import { render, staticRenderFns } from "./expenseform.vue?vue&type=template&id=51afeb36&scoped=true&"
import script from "./expenseform.vue?vue&type=script&lang=js&"
export * from "./expenseform.vue?vue&type=script&lang=js&"
import style0 from "./expenseform.vue?vue&type=style&index=0&id=51afeb36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51afeb36",
  null
  
)

export default component.exports